import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import type { DriveUnavailableActions } from '@mtm/drive/core';

/** Host side of the drive explorer's "content isn't available" dialog: "Go to homepage". */
@Injectable({ providedIn: 'root' })
export class DriveUnavailableActionsAdapter implements DriveUnavailableActions {
  private readonly router = inject(Router);

  goHome(): void {
    void this.router.navigateByUrl('/');
  }
}
